module.exports = __webpack_public_path__ + "static/media/icon-2.7cd5d944.svg";